import { Injectable } from '@angular/core';
// Portal Material Components
import { DefaultComponent } from '../../partials/default/default.component';
import { MaterialHeroComponent } from '../../public/material/hero/hero.component';
import { MaterialBannerComponent } from '../../public/material/banner/banner.component';
import { MaterialContactFormComponent } from '../../public/material/contact-form/contact-form.component';
import { MaterialCtaComponent } from '../../public/material/cta/cta.component';
import { MaterialCtaFormComponent } from '../../public/material/cta-form/cta-form.component';
import { MaterialCtaNewsletterComponent } from '../../public/material/cta-newsletter/cta-newsletter.component';
import { MaterialFeaturesColComponent } from '../../public/material/features-col/features-col.component';
import { MatrialFeaturesRowComponent } from '../../public/material/features-row/features-row.component';
import { MaterialFooterComponent } from '../../public/material/footer/footer.component';
import { MaterialHeaderComponent } from '../../public/material/header/header.component';
import { MaterialHeroImageComponent } from '../../public/material/hero-image/hero-image.component';
import { MaterialHeroVideoComponent } from '../../public/material/hero-video/hero-video.component';
import { MaterialImageGalleryComponent } from '../../public/material/image-gallery/image-gallery.component';
import { MaterialInstagramComponent } from '../../public/material/instagram/instagram.component';
import { MaterialLogosComponent } from '../../public/material/logos/logos.component';
import { MaterialPostsComponent } from '../../public/material/posts/posts.component';
import { MaterialPricingComponent } from '../../public/material/pricing/pricing.component';
import { MaterialTestimonialsComponent } from '../../public/material/testimonials/testimonials.component';
import { MaterialTeamComponent } from '../../public/material/team/team.component';
import { MaterialHeroBackgroundImageComponent } from '../../public/material/hero-background-image/hero-background-image.component';
import { ProductsMaterialComponent } from '../../public/material/Products/products.component';
import { MaterialLogoComponent } from '../../public/material/logo/logo.component';
import { MaterialHeroBackgroundVideoComponent } from '../../public/material/hero-background-video/hero-background-video.component';
import { MaterialFeaturesSliderComponent } from '../../public/material/features-slider/features-slider.component';
import { MaterialCareerComponent } from '../../public/material/career/career.component';
import { MaterialProgressBarComponent } from '../../public/material/progress-bar/progress-bar.component';
import { MaterialTwitterComponent } from '../../public/material/twitter/twitter.component';
import { MaterialMapComponent } from '../../public/material/map/map.component';
import { MaterialContactFormWithMapComponent } from '../../public/material/contact-form-with-map/contact-form-with-map.component';
import { MaterialCtaFormWithMapComponent } from '../../public/material/cta-form-with-map/cta-form-with-map.component';
import { MaterialReservationComponent } from '../../public/material/reservation/reservation.component';
import { SliderImagesMaterialComponent } from '../../public/material/slider/slider.component';
import { MaterialGridImagesComponent } from '../../public/material/grid-images-list/grid-images-list.component';
import { MaterialEcommerceComponent } from '../../public/material/e-commerce/e-commerce.component';
import { MaterialOpenseaComponent } from '../../public/material/opensea/opensea.component';
import { MaterialTestimonialsAltStyleComponent } from 'src/app/public/material/testimonials-alternative-style/testimonials-alternative-style.component';
import { MatrialFeaturesImagesComponent } from 'src/app/public/material/features-images/features-images.component';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {

  getComponentService(componentName: string): any {
    switch (componentName) {
      case 'Hero': {
        return MaterialHeroComponent;
      }
      case 'HeroVideo': {
        return MaterialHeroVideoComponent;
      }
      case 'HeroImage': {
        return MaterialHeroImageComponent;
      }
      case 'HeroBackgroundImage': {
        return MaterialHeroBackgroundImageComponent;
      }
      case 'HeroBackgroundVideo': {
        return MaterialHeroBackgroundVideoComponent;
      }
      case 'Career': {
        return MaterialCareerComponent;
      }
      case 'FeaturesSlider': {
        return MaterialFeaturesSliderComponent;
      }
      case 'FeaturesRow': {
        return MatrialFeaturesRowComponent;
      }
      case 'FeaturesImages': {
        return MatrialFeaturesImagesComponent;
      }
      case 'FeaturesCol': {
        return MaterialFeaturesColComponent;
      }
      case 'Logos': {
        return MaterialLogosComponent;
      }
      case 'Logo': {
        return MaterialLogoComponent;
      }
      case 'Banner': {
        return MaterialBannerComponent;
      }
      case 'ImageGallery': {
        return MaterialImageGalleryComponent;
      }
      case 'CtaForm': {
        return MaterialCtaFormComponent;
      }
      case 'CtaFormWithMap': {
        return MaterialCtaFormWithMapComponent;
      }
      case 'Pricing': {
        return MaterialPricingComponent;
      }
      case 'Cta': {
        return MaterialCtaComponent;
      }
      case 'Testimonials': {
        return MaterialTestimonialsComponent;
        return;
      }
      case 'TestimonialsAltStyle': {
        return MaterialTestimonialsAltStyleComponent;
        return;
      }
      case 'CtaNewsletter': {
        return MaterialCtaNewsletterComponent;
      }
      case 'ProgressBar': {
        return MaterialProgressBarComponent;
      }
      case 'Reservation': {
        return MaterialReservationComponent;
      }
      case 'Slider': {
        return SliderImagesMaterialComponent;
      }
      case 'GridImages': {
        return MaterialGridImagesComponent;
      }
      case 'Team': {
        return MaterialTeamComponent;
      }
      case 'Models': {
        return ProductsMaterialComponent;
      }
      case 'Products': {
        return ProductsMaterialComponent;
      }
      case 'ContactForm': {
        return MaterialContactFormComponent;
      }
      case 'ContactFormWithMap': {
        return MaterialContactFormWithMapComponent;
      }
      case 'Map': {
        return MaterialMapComponent;
      }
      case 'Header': {
        return MaterialHeaderComponent;
      }
      case 'Footer': {
        return MaterialFooterComponent;
      }
      case 'Posts': {
        return MaterialPostsComponent;
      }
      case 'Twitter': {
        return MaterialTwitterComponent;
      }
      case 'Instagram': {
        return MaterialInstagramComponent;
      }
      case "Ecommerce": {
        return MaterialEcommerceComponent;
      }
      case "Opensea": {
        return MaterialOpenseaComponent;
      }
      default: {
        return DefaultComponent;
      }
    }
  };

}